import { QueryClient } from '@tanstack/react-query';

export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      //  refetchInterval: 1,
      retry: false,
      // retry: window._env_.ENVIRONMENT === 'production',
      refetchIntervalInBackground: true,
      refetchOnWindowFocus: false,
      refetchOnMount: false
    }
  }
});
